<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 24 24" fill="none">
    <path
      d="M17 12L10.791 5.71933C10.3996 5.32339 9.76021 5.32337 9.36876 5.71928L8.69521 6.40052C8.30999 6.79014 8.31002 7.41719 8.69528 7.80676L12.8421 12L8.69528 16.1933C8.31002 16.5828 8.30999 17.2099 8.6952 17.5995L9.36876 18.2807C9.7602 18.6766 10.3996 18.6766 10.791 18.2807L17 12Z"
      class="fill-current"
    />
  </svg>
</template>
